import { JSONSchema7Definition } from "json-schema";

import { SELECTED_DATASET_SEARCH_KEY } from "@/config/query-parameter-consts";
import { getRanaWidgetFromProperty } from "@/features/project-process-run-form";
import { DEFAULT_CELL_SIZE } from "@/features/project-process-run-form-cell-size";
import { DatasetByLizardIdQueryDirectly } from "@/queries/query-dataset";

// Get extra properties for a JSON schema property like default values
export const getExtraProperties = async <P extends JSONSchema7Definition>(
  property: P,
  datasetByLizardIdQueryDirectly: DatasetByLizardIdQueryDirectly
): Promise<P> => {
  if (typeof property !== "object") return property;

  const datasetWidget = getRanaWidgetFromProperty(property, "dataset");

  if (datasetWidget) {
    const searchParams = new URLSearchParams(window.location.search);
    const selectedDatasetInSearch = searchParams.get(SELECTED_DATASET_SEARCH_KEY);

    if (selectedDatasetInSearch) {
      // If a dataset is selected in the URL params, use it as the default
      searchParams.delete(SELECTED_DATASET_SEARCH_KEY);
      const newUrl = window.location.origin + window.location.pathname + "?" + searchParams;
      window.history.replaceState(null, "", newUrl);
      return { ...property, default: { id: selectedDatasetInSearch } };
    } else {
      // Get the default dataset from the widget by its lizard id
      const lizardId = datasetWidget?.default && datasetWidget?.default["resourceIdentifier.code"];
      if (!lizardId) return property;
      const { data: dataset } = await datasetByLizardIdQueryDirectly(lizardId);
      if (!dataset) return property;
      return { ...property, default: { id: dataset.id } };
    }
  }

  const cellSizeWidget = getRanaWidgetFromProperty(property, "cell_size");

  if (cellSizeWidget) {
    return { default: DEFAULT_CELL_SIZE, ...property };
  }

  return property;
};
